import React, { FunctionComponent } from 'react';

import { useIntl } from 'react-intl';
import { motion, AnimatePresence } from 'framer-motion';

import { Box } from '@material-ui/core';

import SecondaryButton from '../../../../components/atoms/SecondaryButton';
import PrimaryButton from '../../../../components/atoms/PrimaryButton';

type WizardNavigation = {
  disabled: boolean;
  step: number;
  user: any;
  actions: {
    onLogout: () => void;
    previousStep: () => void;
    nextStep: () => void;
  };
};

const WizardNavigation: FunctionComponent<WizardNavigation> = ({
  disabled,
  step,
  user,
  actions: { onLogout, previousStep, nextStep },
}) => {
  const { formatMessage } = useIntl();

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box>
            {user && step < 2 && (
              <SecondaryButton onClick={onLogout} tabIndex={-1}>
                {formatMessage({ id: 'general.logout' })}
              </SecondaryButton>
            )}
            {step >= 2 && (
              <SecondaryButton
                disabled={step < 2}
                onClick={previousStep}
                tabIndex={-1}
              >
                {formatMessage({ id: 'general.back' })}
              </SecondaryButton>
            )}
          </Box>
          <Box>
            {step <= 5 && (
              <PrimaryButton
                disabled={step > 5 || disabled}
                onClick={nextStep}
                tabIndex={0}
              >
                {formatMessage({ id: 'general.next' })}
              </PrimaryButton>
            )}
          </Box>
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default WizardNavigation;
